import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BackLink from './BackLink';
import ProjectTags from './ProjectTags';
import ProjectActionLink from './ProjectActionLink';
import './shared.css';
import './Project.css';

const ProjectTemplate = ({ project, relatedPosts = [] }) => {
    return (
        <Container className="py-5">
            <Row>
                <Col>
                    <BackLink toLink="/projects" linkText="Back to all projects" />
                </Col>
            </Row>

            <Row>
                <Col>
                    <h1 className="page-title">{project.title}</h1>
                </Col>
            </Row>

            {project.tags?.length > 0 && (
                <Row>
                    <Col className="project-page__tags">
                        <ProjectTags tags={project.tags} />
                    </Col>
                </Row>
            )}

            {project.image && (
                <Row>
                    <Col>
                        <img
                            src={project.image}
                            alt={`${project.title} screenshot`}
                        />
                    </Col>
                </Row>
            )}

            <Row>
                <Col>
                    <p>{project.summary}</p>
                </Col>
            </Row>

            {(project.sourceUrl || project.liveUrl) && (
                <Row>
                    <Col className="project-page__actions">
                        {project.sourceUrl && (
                            <ProjectActionLink url={project.sourceUrl} linkText="Source ↗" />
                        )}

                        {project.liveUrl && (
                            <ProjectActionLink url={project.liveUrl} linkText="View live ↗" />
                        )}
                    </Col>
                </Row>
            )}

            {relatedPosts.length > 0 && (
                <Row>
                    <Col>
                        <section>
                            <h2>Project Articles</h2>
                            <div className="blog-list px-4 mt-4">
                                {relatedPosts.map((post) => (
                                    <article className="blog-post-row" key={post.slug}>
                                        <Link to={`/blog/${post.slug}`}>
                                            {post.title}
                                        </Link>

                                        {post.summary && (
                                            <p>{post.summary}</p>
                                        )}
                                    </article>
                                ))}
                            </div>
                        </section>
                    </Col>
                </Row>
            )}

        </Container>
    );
};

export default ProjectTemplate;